import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom";
import AddToWishlistButton from "../AddToWishlistButton/AddToWishlistButton";

// Just some consts
const LIST_NODE_CLASSNAME = "list-products";
const ITEM_NODE_CLASSNAME = "list-products__item";
const PORTAL_NODE_CLASSNAME = "wishlist-portal";

const ProductListWishlistButtonsPortal: React.FC = () => {
  const [productElements, setProductElements] = useState<HTMLElement[]>(
    Array.from(document.body.getElementsByClassName(ITEM_NODE_CLASSNAME)) as HTMLElement[],
  );

  useEffect(() => {
    const target = document.body.getElementsByClassName(LIST_NODE_CLASSNAME)[0];
    if (!target) {
      return;
    }
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((record) => {
        const node = record.addedNodes[0];
        if (
          node instanceof HTMLElement &&
          node.className.includes(ITEM_NODE_CLASSNAME) &&
          !node.getElementsByClassName(PORTAL_NODE_CLASSNAME)[0]
        ) {
          setProductElements(Array.from(document.body.getElementsByClassName(ITEM_NODE_CLASSNAME)) as HTMLElement[]);
        }
      });
    });

    const conf: MutationObserverInit = {childList: true};
    observer.observe(target, conf);

    return () => {
      observer.disconnect();
    };
  }, []);

  if (!productElements.length) {
    return null;
  }

  const productElementsNoLargeImageAndItemIdSet = productElements.filter(
    (productElement) => !productElement.classList.contains("largeimage") && !!productElement.dataset.gtmIid,
  );

  if (!productElementsNoLargeImageAndItemIdSet.length) {
    return null;
  }

  return (
    <React.Fragment>
      {productElementsNoLargeImageAndItemIdSet.map((element) => {
        const itemId = Number(element.dataset.gtmIid);
        let wishlistButtonSpan = element.getElementsByClassName(PORTAL_NODE_CLASSNAME)[0];
        if (!wishlistButtonSpan) {
          wishlistButtonSpan = document.createElement("span");
          wishlistButtonSpan.className = PORTAL_NODE_CLASSNAME;
          element.appendChild(wishlistButtonSpan);
        }

        return ReactDOM.createPortal(
          <AddToWishlistButton itemId={itemId} animated={true} size={"small"} />,
          wishlistButtonSpan,
        );
      })}
    </React.Fragment>
  );
};

export default ProductListWishlistButtonsPortal;
